import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React from "react";
import { Container, Modal } from "react-bootstrap";
import { ReusableOnboardingMapButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";

function AddOnModel(props) {
  return (
    <div>
      <Modal
        show={props.open}
        size="lg"
        onHide={() => props.setaddonmodel(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add On Option Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <div className="f16-500">Add-On Option Item Name</div>
            <div className="mt-3">
              <TextField variant="outlined" label="Item Name" fullWidth />
            </div>
            <div className="f16-500 mt-3">
              Is this Item Available in One Size or Multiple Sizes?
            </div>
            <FormControl component="fieldset">
              {/* <FormLabel component="legend">labelPlacement</FormLabel> */}
              <RadioGroup
                row
                aria-label="position"
                name="position"
                defaultValue="top"
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="One Size"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="Multiple Size"
                />
              </RadioGroup>
            </FormControl>
            <div className="f16-500 mt-3">Item Price</div>
            <div className="mt-3">
              <TextField variant="outlined" label="value" />
            </div>{" "}
            <div className="f16-500 mt-3">Is this veg or Non Veg?</div>
            <FormControl component="fieldset">
              {/* <FormLabel component="legend">labelPlacement</FormLabel> */}
              <RadioGroup
                row
                aria-label="position"
                name="position"
                defaultValue="top"
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="Veg"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="Non Veg/Egg/Other"
                />
              </RadioGroup>
            </FormControl>
            <div className="f16-500 mt-3">Food Type</div>
            <div className="mt-3">
              <div
                className={
                  foodType.length > 8 ? "cuisine-main-padding-border" : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding justify-content-start column-3"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {foodType.map((icon, index) => {
                    return (
                      <div className="col-3 mt-3">
                        <div
                          className={
                            // selectedIcons.some(
                            //   (icons) => icons._id === icon._id
                            // )
                            //   ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                            //   :
                            "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          }
                          //   onClick={onClick}
                        >
                          <span
                            className="para-data-icon"
                            style={{ color: "#212121" }}
                          >
                            {icon.title}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6">
                <div className="f16-500 mt-3">Nutritional Information</div>
              </div>
              <div className="col-6 mt-2">
                <div className="d-flex">
                  <div className="f12-400 mr-3">No</div>
                  <Toggle />
                  <div className="f12-400 ml-3">Yes</div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-3">
                <div className="f16-500 mt-3">Calories</div>
              </div>
              <div className="col-6">
                <div className="mt-3">
                  <TextField variant="outlined" label="value" />
                </div>{" "}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6">
                <div className="f16-500 mt-3">Allergy Information</div>
              </div>
              <div className="col-6 mt-2">
                <div className="d-flex">
                  <div className="f12-400 mr-3">No</div>
                  <Toggle />
                  <div className="f12-400 ml-3">Yes</div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div
                className={
                  foodType.length > 8 ? "cuisine-main-padding-border" : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding justify-content-start column-3"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {allergyInfo.map((icon, index) => {
                    return (
                      <div className="col-3 mt-3">
                        <div
                          className={
                            // selectedIcons.some(
                            //   (icons) => icons._id === icon._id
                            // )
                            //   ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                            //   :
                            "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          }
                          //   onClick={onClick}
                        >
                          {icon.src ? (
                            <img src={icon.src} alt="icon" title={icon.title} />
                          ) : null}
                          <span
                            className="para-data-icon"
                            style={{ color: "#212121" }}
                          >
                            {icon.title}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>{" "}
          </Container>
        </Modal.Body>

        <Modal.Footer className="justify-content-start border-0">
          <button
            type="button"
            class="btn-md mr-4 px-5 btn btn-outline-secondary"
            onClick={() => props.setaddonmodel(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn-md px-5 btn btn-danger"
            // onClick={() => deleteCatalog()}
          >
            Done
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

const foodType = [
  { title: "Crustacean" },
  { title: "Gluten Free" },
  { title: "Halal" },
  { title: "Kosher" },
  { title: "Lactose Free" },
  { title: "Nuts Free" },
  { title: "Organic" },
  { title: "Pescatarian" },
  { title: "Seafood" },
  { title: "Vegan" },
  { title: "Vegetarian" },
  { title: "Eggetarian" },
];

const allergyInfo = [
  { title: "Milk", src: "" },
  { title: "Soy", src: "" },
  { title: "Gluten", src: "" },
  { title: "Nuts", src: "" },
  { title: "Seafood", src: "" },
  { title: "Egg", src: "" },
  { title: "Sesame", src: "" },
  { title: "Mushroom", src: "" },
];

export default AddOnModel;
